import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionLabel,
  onAction,
  secondaryLabel,
  secondaryTo,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center py-16 px-6 text-center bg-background-100 rounded-lg border border-background-200">
      <span className="w-16 h-16 rounded-full bg-background-200 text-foreground-500 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="text-base md:text-lg font-semibold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-600 max-w-md">{description}</p>}
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="px-4 py-2 rounded-md text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {actionLabel}
          </button>
        )}
        {secondaryLabel && secondaryTo && (
          <Link
            to={secondaryTo}
            className="px-4 py-2 rounded-md text-sm font-medium border border-background-300 text-foreground-800 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
}